import { onSnapshot } from "../config/dataClient";

// daily_status supplies roster membership; each profile stays live independently.
export function subscribePersonnel(rosterRef, profileRef, onChange, onError = console.error) {
  const profiles = new Map();
  let roster = [];
  let disposed = false;

  const publish = () => {
    if (disposed) return;
    // Do not briefly classify someone using only daily_status before their
    // profile has arrived (it may contain a hidden/archive flag or end date).
    onChange(roster.filter(({ uid }) => profiles.get(uid)?.ready).map(entry => ({
      ...entry, profileData: profiles.get(entry.uid).data,
    })));
  };

  const unsubscribeRoster = onSnapshot(rosterRef, snapshot => {
    if (disposed) return;
    roster = snapshot.docs.map(d => {
      const dailyData = d.data();
      return { uid: dailyData.uid || d.id, dailyData };
    });
    const currentUids = new Set(roster.map(({ uid }) => uid));
    for (const [uid, entry] of profiles) {
      if (!currentUids.has(uid)) {
        profiles.delete(uid);
        entry.unsubscribe();
      }
    }
    for (const { uid } of roster) {
      if (profiles.has(uid)) continue;
      const entry = { ready: false, data: {}, unsubscribe: () => {} };
      profiles.set(uid, entry);
      entry.unsubscribe = onSnapshot(profileRef(uid), snap => {
        // Ignore callbacks queued before removal, re-addition or unmount.
        if (disposed || profiles.get(uid) !== entry) return;
        entry.data = snap.exists() ? snap.data() : {};
        entry.ready = true;
        publish();
      }, error => {
        if (disposed || profiles.get(uid) !== entry) return;
        entry.ready = false;
        publish();
        onError(error);
      });
    }
    publish();
  }, error => {
    if (!disposed) onError(error);
  });

  return () => {
    disposed = true;
    unsubscribeRoster();
    for (const entry of profiles.values()) entry.unsubscribe();
    profiles.clear();
  };
}
